import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TruckDriversFacade } from './truck-drivers.facade';

@Injectable({
  providedIn: 'root',
})
export class TruckDriversGuard {
  constructor(private truckDriversFacade: TruckDriversFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.truckDriversFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.truckDriversFacade);
  }
}
